import { c as _c } from "react/compiler-runtime";
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragAndDropIcon } from '@systemeio/icons';
import { PricePlanType } from '@systemeio/types';
import { PricePlanRow } from 'modules/digital-product/price-plans/components/price-plan-row';
import React, { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';
const animateLayoutChanges: AnimateLayoutChanges = args => defaultAnimateLayoutChanges({
  ...args,
  wasDragging: true
});
interface SortablePricePlanRowProps extends ComponentProps<typeof PricePlanRow> {
  pricePlan: PricePlanType;
}

/** Price plan row with a drag handle; the list decides when reordering is available. */
export function SortablePricePlanRow(t0) {
  const $ = _c(21);
  const {
    pricePlan,
    ...rowProps
  } = t0;
  let t1;
  if ($[0] !== pricePlan.id) {
    t1 = {
      id: pricePlan.id,
      animateLayoutChanges
    };
    $[0] = pricePlan.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform
  } = useSortable(t1);
  const t2 = "flex items-center gap-2";
  let t3;
  if ($[2] !== transform) {
    t3 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isDragging ? 0.5 : undefined;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      transform: t3,
      opacity: t4
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DragAndDropIcon className="text-icon-tertiary size-5" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== attributes || $[9] !== listeners) {
    t7 = <span className="focus-visible:focus-ring-primary flex shrink-0 cursor-grab rounded outline-none" {...listeners} {...attributes}>{t6}</span>;
    $[8] = attributes;
    $[9] = listeners;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const T0 = PricePlanRow;
  const t8 = twMerge("flex-1", rowProps.className);
  let t9;
  if ($[11] !== T0 || $[12] !== pricePlan || $[13] !== rowProps || $[14] !== t8) {
    t9 = <T0 {...rowProps} className={t8} pricePlan={pricePlan} />;
    $[11] = T0;
    $[12] = pricePlan;
    $[13] = rowProps;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== setNodeRef || $[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
    t10 = <div ref={setNodeRef} className={t2} style={t5}>{t7}{t9}</div>;
    $[16] = setNodeRef;
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}